import { render, staticRenderFns } from "./CallBack.vue?vue&type=template&id=28254296&scoped=true"
import script from "./CallBack.vue?vue&type=script&lang=js"
export * from "./CallBack.vue?vue&type=script&lang=js"
import style0 from "./CallBack.vue?vue&type=style&index=0&id=28254296&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28254296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28254296')) {
      api.createRecord('28254296', component.options)
    } else {
      api.reload('28254296', component.options)
    }
    module.hot.accept("./CallBack.vue?vue&type=template&id=28254296&scoped=true", function () {
      api.rerender('28254296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauth/CallBack.vue"
export default component.exports